import React from 'react';
import Styles from './ContainerHome24.css';
/**
 * @param {string} type Recebe o tipo da tag a ser retornada.
 * @description ContainerHome24 semelhante ao ContainerHome24 do Bootstrap
 */
function ContainerHome24({ fullMobile, type, extraPadding, noPadding, children, ...props }) {
  return (
    <>
      {type === 'div' && (
        <div
          {...props}
          className={`
            ctn-home-24 
            ${!!fullMobile ? 'ctn-f-mb' : ''} 
            ${extraPadding ? 'ctn-e-p' : ''} 
            ${noPadding ? 'ctn-rm-p' : ''} 
            ${props.className || ''}
          `.replace(/\s\s+/g, ' ')}
        >
          {children}
        </div>
      )}
      {type === 'ul' && (
        <ul {...props} className={`ctn-home-24 ${props.className || ''}`}>
          {children}
        </ul>
      )}
      {type === 'article' && (
        <article {...props} className={`ctn-home-24 ${props.className || ''}`}>
          {children}
        </article>
      )}
      {type === 'section' && (
        <section
          {...props}
          className={`
            ctn-home-24 
            ${!!fullMobile ? 'ctn-f-mb' : ''} 
            ${extraPadding ? 'ctn-e-p' : ''} 
            ${noPadding ? 'ctn-rm-p' : ''} 
            ${props.className || ''}
          `.replace(/\s\s+/g, ' ')}
        >
          {children}
        </section>
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

ContainerHome24.defaultProps = {
  type: 'div',
};

export default ContainerHome24;
